import {gsap, ScrollTrigger} from "gsap/all";
import * as Helper from './Helpers';

gsap.registerPlugin(ScrollTrigger);
gsap.config({nullTargetWarn: false});
gsap.defaults({ease: "none"});

class DevicesFilter {
    constructor() {
        this.containers = document.querySelectorAll('.section-devices');
        if (this.containers.length === 0) return;

        this.containers.forEach(container => {
            this.bindEvents(container);
            this.animationStickyModal(container);
        });
    }

    bindEvents(container) {
        container.addEventListener('click', event => {
            const target = event.target.closest('.filter-btn, [data-modal-compare-trigger], [data-modal-product-close], .devices-filter-clear, .filter-more-btn, [data-sticky-modal], tr.parent, [data-image], [data-map-modal-close], [data-panel-product-close], [data-panel-trigger]');
            if (!target) return;

            let buttons, countersTargets, clearButtons, counterProductsTarget, posts;

            switch (true) {
                case target.classList.contains('filter-btn'):
                    this.toggleButton(target);
                    buttons = container.querySelectorAll('.filter-btn');
                    countersTargets = container.querySelectorAll('.count');
                    clearButtons = container.querySelectorAll('.devices-filter-clear');
                    counterProductsTarget = container.querySelector('.count-product');
                    posts = Array.from(container.querySelectorAll('.post-product'));
                    this.filterPosts(container, posts, buttons, countersTargets, clearButtons, counterProductsTarget);
                    break;
                case target.matches('[data-modal-compare-trigger]'):
                    event.preventDefault();
                    this.openModals(container.querySelector('[data-modal-compare-box]'));
                    break;
                case target.matches('[data-modal-product-close]'):
                    event.preventDefault();
                    this.closeModals(container.querySelector('[data-modal-compare-box]'));
                    break;
                case target.matches('[data-panel-trigger]'):
                    event.preventDefault();
                    this.openModals(container.querySelector('[data-panel-product]'));
                    break;
                case target.matches('[data-panel-product-close]'):
                    event.preventDefault();
                    this.closeModals(container.querySelector('[data-panel-product]'));
                    break;
                case target.classList.contains('devices-filter-clear'):
                    buttons = container.querySelectorAll('.filter-btn');
                    countersTargets = container.querySelectorAll('.count');
                    this.clearFilter(buttons, countersTargets);
                    clearButtons = container.querySelectorAll('.devices-filter-clear');
                    counterProductsTarget = container.querySelector('.count-product');
                    posts = Array.from(container.querySelectorAll('.post-product'));
                    this.filterPosts(container, posts, buttons, countersTargets, clearButtons, counterProductsTarget);
                    this.toggleNotFound(container, true);
                    break;
                case target.classList.contains('filter-more-btn'):
                    event.preventDefault();
                    this.filterAccordion(target, container);
                    break;
                case target.matches('[data-sticky-modal]'):
                    event.preventDefault();
                    this.closeStickyModal(container.querySelector('.sticky-modal'));
                    break;
                case target.matches('[data-map-modal-close]'):
                    event.preventDefault();
                    this.closeMapModal(container.querySelector('[data-modal-map-box]'));
                    break;
                case target.matches('[data-image]'):
                    event.preventDefault();
                    this.openMapModal(target, container.querySelector('[data-modal-map-box]'));
                    break;
                case target.classList.contains('parent'):
                    event.preventDefault();
                    this.categoryAccordion(target);
                    break;
                default:
                    break;
            }
        });

        window.addEventListener('keydown', event => {
            if (event.key === 'Escape') {
                this.closeAllModals(container);
            }
        });

        window.addEventListener('resize', ()=>{
            this.closeModals(container.querySelector('[data-panel-product]'));
        })
    }

    toggleButton(button) {
        let section = button.closest('.section-devices');
        let attr = button.getAttribute('data-category')
        let buttons = section.querySelectorAll(`[data-category="${attr}"]`);

        buttons.forEach(b => {
            b.classList.toggle('gpx-filter-active');
        })
    }

    filterPosts(container, posts, buttons, counterTargets, clearButtons, counterProductsTarget) {
        const activeCategories = [];
        const activeFilterCats = [];
        let table = container.querySelector('table.product-table');
        buttons.forEach(button => {
            if (button.classList.contains('gpx-filter-active')) {
                const parent = +button.dataset.parentCat;
                const child = button.dataset.category;
                const recordedParent = activeFilterCats.find(entry => entry.parent === parent);

                if(recordedParent){
                  if(!recordedParent.child.includes(child)) {
                    recordedParent.child = [...recordedParent.child, child];
                    activeCategories.push(child);
                  }
                }else{
                  activeFilterCats.push({
                    parent,
                    child: [child],
                  })
                  activeCategories.push(child);
                }
                
            }
        });

        this.updateCountFilter(activeCategories, counterTargets);
        this.clearButtonsToggle(clearButtons, true);

        if (activeCategories.length === 0) {
            this.clearButtonsToggle(clearButtons, false);
            table.style = ''
            let productCount = counterProductsTarget.getAttribute('data-start-count');
            this.updateCountProducts(Number(productCount), counterProductsTarget)

            posts.forEach(post => {
                post.style = '';
                post.classList.add('show-cell');
            });
            return;
        }

        posts.forEach(post => {
            const dataCats = post.dataset.filterCat.split(', ');
            const postCategories = {
              parent: [],
              child: [],
            }
            
            dataCats.forEach(entry => {
              const data = entry.split(' | ');
              const parent = +data[0];
              const child = data[1];

              if(!postCategories.parent.includes(parent)) postCategories.parent = [... postCategories.parent, parent];
              if(!postCategories.child.includes(child)) postCategories.child = [... postCategories.child, child];

            });

            const isVisible = activeFilterCats.every(cat => cat.child.some(child => postCategories.child.includes(child)));


            if (isVisible) {
                post.style = '';
                post.classList.add('show-cell');
            } else {
                post.style.display = 'none';
                post.classList.remove('show-cell');
            }
        });

        let tableCell = container.querySelectorAll('table.product-table thead tr th.show-cell').length;
        this.toggleNotFound(container, !!tableCell);
        table.style.width = `${309 + 200 * tableCell}px`;
        this.updateCountProducts(tableCell, counterProductsTarget)
    }

    updateCountFilter(activeCategories = [], counterTargets) {
        counterTargets.forEach(item => {
            item.textContent = activeCategories.length === 0 ? '' : `(${activeCategories.length})`
        })
    }

    updateCountProducts(products, counterProductsTarget) {
        counterProductsTarget.textContent = `(${products})`
    }

    clearButtonsToggle(clearButtons, show) {
        clearButtons.forEach(button => {
            if(button.classList.contains('toggle-ignore')) return;
            if (show) {
                button.classList.add('gpx-show-button')
            } else {
                button.classList.remove('gpx-show-button')
            }
        })
    }

    clearFilter(buttons, counterTargets) {
        buttons.forEach(button => {
            button.classList.remove('gpx-filter-active');
        });

        counterTargets.forEach(item => {
            item.textContent = `(0)`;
        });
    }

    openModals(modal) {
        document.body.classList.add('modal-product-active');
        modal.classList.add('show');
    }

    closeModals(modal) {
        document.body.classList.remove('modal-product-active');
        modal.classList.remove('show');
    }

    animationStickyModal(container) {
        const stickyModalTL = gsap.timeline();
        stickyModalTL.fromTo(container.querySelector('.sticky-modal'), {
            opacity: 0, duration: 0.1
        }, {opacity: '100%'}, 0)
        stickyModalTL.fromTo(container.querySelector('.sticky-modal__body'), {
            pointerEvents: "none", duration: 0.1
        }, {pointerEvents: "auto"}, 0)

        ScrollTrigger.create({
            trigger: container,
            star: "top",
            end: "bottom 60%",
            animation: stickyModalTL,
            toggleActions: "play reverse play play",
        })
    }

    closeStickyModal(modal) {
        modal.classList.add('hidden');
    }

    filterAccordion(button, filterWrap) {
        button.querySelector('.closed-btn-text')?.classList.toggle('!hidden');
        button.querySelector('.opened-btn-text')?.classList.toggle('!hidden');

        button.querySelector('.arrow')?.classList.toggle('rotate-arrow-180');

        const showMoreContent = filterWrap.querySelector('.show-more-content');
        showMoreContent.classList.toggle('opened');
        this.contentToggleAnimation(showMoreContent);
    }

    contentToggleAnimation(showMoreContent) {
        if (showMoreContent.classList.contains('opened')) {
            gsap.to(showMoreContent, {
                height: "auto",
                duration: 0.5,
                ease: "power1.inOut",
                onComplete: Helper.parallaxOverlapAnimation // reinit height
            });
        } else {
            gsap.to(showMoreContent, {
                height: "0",
                duration: 0.5,
                ease: "power1.inOut",
                onComplete: Helper.parallaxOverlapAnimation // reinit height
            });
        }
    }

    categoryAccordion(target) {
        let nextRow = target.nextElementSibling;
        target.classList.toggle('open');
        target.querySelector('span.arrow').classList.toggle('rotate-180');

        while (nextRow && !nextRow.classList.contains('parent')) {
            if (nextRow.classList.contains('child')) {
                nextRow.classList.toggle('open');
            }
            nextRow = nextRow.nextElementSibling;
        }
    }

    openMapModal(target, modal) {
        modal.querySelector('.map-image').style.backgroundImage = `url(${target.getAttribute('data-image')})`
        modal.classList.add('show');
    }

    closeMapModal(modal) {
        modal.classList.remove('show');
    }

    closeAllModals(container) {
        const modals = container.querySelectorAll('.modal-product, .modal-map, .panel-modal');
        modals.forEach(modal => {
            modal.classList.remove('show');
        });
        document.body.classList.remove('modal-product-active');
    }

    gsapMatchMedia() {
        let mm = gsap.matchMedia();
        mm.add("(min-width: 1024px)", () => {
        })
        mm.add("(max-width: 1023px)", () => {
        })
    }

    toggleNotFound(container, action){
      const nothingFound = container.querySelector('[data-nothing-found]');
      const results = container.querySelector('[data-results]');
      const modal = container.querySelector('[data-compare-modal]');
      const cta = container.querySelector('[data-cta]');
      const toggle = typeof action === 'boolean' ? action : nothingFound.classList.contains('hidden');
      
      nothingFound.classList.toggle('hidden', toggle);
      results.classList.toggle('hidden', !toggle);
      modal.classList.toggle('hidden', !toggle);
      cta.classList.toggle('mt-64', toggle);
    }
}

export default DevicesFilter;